import { Dropdown, MenuProps } from "antd";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import clsx from "clsx";
import { matchPath, useNavigation } from "react-router";

import { organizationName, useOrganization } from "../../contexts/organization";

function useIsOrgaChanging(activeOrganizationId: string | undefined) {
  const navigation = useNavigation();

  if (navigation.location == null) {
    return false;
  }

  const nextId = matchPath("/:id/*", navigation.location?.pathname)?.params.id;
  return navigation.state === "loading" && activeOrganizationId !== nextId;
}

export function OrganizationSwitcher({ className }: { className?: string }) {
  const { organizations, activeOrganization, setActiveOrganization } = useOrganization();
  const isOrgaChanging = useIsOrgaChanging(activeOrganization?.id);

  const items: MenuProps["items"] = organizations
    .toSorted((a, b) => organizationName(a).localeCompare(organizationName(b)))
    .map((o) => ({
      key: o.id,
      label: organizationName(o),
    }));

  if (items.length === 1) {
    return (
      <span className={clsx("inline-flex text-nowrap", className)}>
        <span className="flex-1 truncate">{organizationName(activeOrganization)}</span>
      </span>
    );
  }

  return (
    <Dropdown menu={{ items, onClick: (e) => setActiveOrganization(e.key) }} trigger={["click"]}>
      <span
        className={clsx("inline-flex items-center cursor-pointer text-nowrap gap-2", className)}
      >
        <span className="flex-1 truncate">{organizationName(activeOrganization)}</span>
        {isOrgaChanging ? (
          <LoadingOutlined className="text-disabled flex-none text-xs" spin />
        ) : (
          <DownOutlined aria-hidden className="flex-none text-xs" />
        )}
      </span>
    </Dropdown>
  );
}
